<template>
  <div class="ion-padding popover-content">
    {{ word }}
    <ul>
      <li v-for="(paraphrase, index) in dataList" :key="index">
        {{ paraphrase }}
      </li>
    </ul>
    <div v-if="!readingId" class="btn-add-word" @click="handleAddWord(word)">
      <span class="btn-plus">+</span><span>加入生词本</span>
    </div>
  </div>
</template>
<script>
import { popoverController, toastController } from "@ionic/vue";

//import {Toast} from "@ionic-native/toast";

export default {
  name: "ReadingPopover",

  props: ["word", "readingId"],
  setup() {
    return {};
  },
  data() {
    return {
      dataList: [],
      queryForm: {},
    };
  },

  mounted() {
    this.userinfo = this.store.getUser();
    this.queryReadingWord();
  },
  methods: {
    handleAddWord(word) {
      const appointment = this.store.getAppointment();
      const param = {
        aptmId: appointment.aptmId,
        courseId: appointment.courseId,
        word: word.trim(),
      };
      this.ajax.post("/readingVocabulary/addReadingWordToPersonal", param).then(async (res) => {
        if (res.data.success) {
          const toast = await toastController.create({
            message: res.data.messageExtra,
            duration: 1500,
            cssClass: "my-toast-class",
          });
          await toast.present();
        }
      });
      popoverController.dismiss();
    },

    //查询阅读理解文章
    queryReadingWord() {
      this.ajax.get("/readingVocabulary/getReadingWordDetail?word=" + this.word).then((res) => {
        if (res.data.success) {
          this.dataList = res.data.list;
        }
      });
    },
  },
};
</script>
<style scoped>
.popover-content {
  width: 100%;
  height: 100%;
}
ul {
  list-style-type: none;
  padding: 0;
}

ul li {
  margin: 0;
  font-size: 1em;
}

.btn-add-word {
  border: 1px solid lightgray;
  font-size: 0.8rem;
  padding-right: 10px;
  display: inline-block;
  height: 1.5rem;
  line-height: 1.5rem;
  border-radius: 10px;
}

.btn-add-word .btn-plus {
  font-weight: bold;
  color: #21c73c;
  margin: 0 0.5rem;
}
</style>

<style>
.my-toast-class {
  --background: #21c73c;
  --color: white;
}
</style>
